export interface SaleStartDates {
  listingPlanDate: string | null; // 販売開始予定日(薬価収載)
  saleStartPlanDate: string | null; // 販売開始予定日(販売開始)
  listingDate: string | null; // 薬価収載年月日
  saleStartDate: string | null; // 販売開始年月日
}

export const extractSaleStartDates = (
  saleStartExpectedDate: string | null | undefined
): SaleStartDates => {
  const result: SaleStartDates = {
    listingPlanDate: null,
    saleStartPlanDate: null,
    listingDate: null,
    saleStartDate: null,
  };

  if (!saleStartExpectedDate) return result;

  // 改行コードを統一
  const normalized = saleStartExpectedDate.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // 行に分割
  const lines = normalized.split('\n');

  // 行からの数値抽出関数
  const extractDateFromLine = (line: string): string | null => {
    if (!line || line.trim() === '') return null;
    const match = line.match(/(\d{4,8})/);
    return match ? (match[1] as string) : null;
  };

  // 1行目: 販売開始予定日(薬価収載)
  if (lines.length >= 1) {
    result.listingPlanDate = extractDateFromLine(lines[0]);
  }

  // 2行目: 販売開始予定日(販売開始)
  if (lines.length >= 2) {
    result.saleStartPlanDate = extractDateFromLine(lines[1]);
  }

  // 4行目: 薬価収載年月日 (インデックスは3)
  if (lines.length >= 4) {
    result.listingDate = extractDateFromLine(lines[3]);
  }

  // 5行目: 販売開始年月日 (インデックスは4)
  if (lines.length >= 5) {
    result.saleStartDate = extractDateFromLine(lines[4]);
  }

  return result;
};
